import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "../i18n/translations";

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [lang, setLang] = useState(() => {
        if (typeof window === "undefined") return "en";
        return localStorage.getItem("amos_lang") || "en";
    });

    useEffect(() => {
        localStorage.setItem("amos_lang", lang);
        document.documentElement.lang = lang;
    }, [lang]);

    const t = (key) => {
        const parts = key.split(".");
        let val = translations[lang];
        for (const p of parts) {
            if (val && typeof val === "object" && p in val) val = val[p];
            else return key;
        }
        return val;
    };

    const toggle = () => setLang((p) => (p === "en" ? "gr" : "en"));

    return (
        <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLang = () => useContext(LanguageContext);
